import { useTranslation } from 'react-i18next'
import axios from '@fs/zion-axios'
import { geoData } from '@fs/zion-config'
import useFetchData from './useFetchData'
import getStdLocale from './getStdLocale'

async function fetchCountries(fsLanguageCode) {
  const RUSSIA_ID = 75
  const { data } = await axios.get('/service/standards/place/ws/places/place-rep-groups/63', {
    params: { 'accept-language': getStdLocale(fsLanguageCode) },
  })
  let places = data.placeRepGroup.placeReps || []
  if (geoData.country !== 'RU') {
    places = places.filter(({ id }) => id !== RUSSIA_ID)
  }
  return (
    places
      .map((x) => {
        return { key: x.id, value: `${x.id}`, label: x.display.name }
      })
      // put the list of countries in alphabetic order
      .sort((a, b) => {
        return a.label.localeCompare(b.label)
      })
  )
}

export default function useCountryOptions() {
  const { i18n } = useTranslation()
  const { data: countryOptions, loading: countryOptionsLoading } = useFetchData(fetchCountries, {
    initialData: [],
    requestFnArg: i18n.language,
  })
  return { countryOptions, countryOptionsLoading }
}
